import { Component, Injectable } from '@angular/core';
import { AlertService } from '../../../shared/alert/services/alert.service';
import { UrlService } from '../../../shared/services/url.service';
import { SignalsService } from '../../services/signals.service';
import { CloseSignal } from '../../models/CloseSignal';
import { MatDialog } from '@angular/material';
import { ConfirmationModalComponent } from './confirmationModal.component';
import * as moment from 'moment-timezone';
import { SideBarService } from '../../../shared/services/sideBarService';
import { SignalsMainComponent } from './main.component';

@Component({
  selector: 'app-signals-sync',
  templateUrl: '../templates/signalsSync.component.html'
})

@Injectable()
export class SignalsSyncComponent extends SignalsMainComponent {

  title = 'Signals Sync';
  DashboardUrl = '';
  inProgress = true;

  signal: CloseSignal;

  constructor(
    private urlService: UrlService,
    private signalsService: SignalsService,
    private alertService: AlertService,
    private dialog: MatDialog,
    sideBarService: SideBarService) {
    super(sideBarService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.Init();
  }

  Init(): void {
    this.DashboardUrl = this.urlService.GetDashboardRoute();
    this.signal = {
      ClosingPrice: 0,
      PositionMaintenanceId: '',
      ClosingTime: moment.utc(moment())
    };
  };

  Update(): void {
    this.alertService.removeAll();
    if(this.isValidSignal()){
      this.dialog.open(ConfirmationModalComponent, {
        hasBackdrop: true,
        backdropClass: 'fxstreet-modal-backdrop',
        panelClass: 'fxstreet-preview-dialog-panel',
        position: { top: '150px' },
        data: {
          details: this.signal,
          title: 'Update Signal',
          message: 'Are you sure you want to update this signal?'
        }
      })
      .afterClosed()
      .subscribe(shouldUpdate => {
        if (shouldUpdate){
          this.inProgress = true;
          this.signalsService.Update(this.signal as CloseSignal)
            .subscribe(response => {
              this.inProgress = false;
              if(response)
                this.alertService.add('success', 'Signal successfully updated');
            })
        }
      });
    }
  };

  isValidSignal(): boolean {
    var result = true;
    if (this.isNullOrWhiteSpace(this.signal.PositionMaintenanceId)){
      this.alertService.add('danger','Wrong PositionMaintenanceId. Please check.');
      result=false;
    }
    if(this.signal.ClosingPrice <= 0){
      this.alertService.add('danger','Wrong ClosingPrice. Please check.');
      result=false;
    }

    return result;
  };

  isNullOrWhiteSpace(value:string): boolean{
    return (value && value.trim()) ? false : true;
  };
}



// WEBPACK FOOTER //
// ./src/app/tradingstudio/components/scripts/signalsSync.component.ts